export default __webpack_public_path__ + "static/media/plus.88539dce.svg";